import axios from 'axios'
import {
  getBackfill,
  getShopifyBackfill,
  getPaypalBackfill,
  getMerchantPaypalBackfill,
  getBigcommerceBackfill,
  getWoocommerceBackfill,
  getBackfillStatus,
  getBackfillRunningStatus,
  inkfrogOrdersBackfillUrl,
} from 'urls'
import { setCookie } from 'cookie'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { localStoragePayhelm, getAxiosDefaultConfig } from 'modules/utils'
import { getTriggerBackfillDetails } from '../features/backfill/helpers'

let backfillInterval, runningBackfillInterval
// Bumped whenever we re-discover / watch a new backfill so an in-flight status
// poll whose axios call already started cannot clobber Redux with a stale token.
let backfillPollGeneration = 0
// IDs we've seen in 'running' status this session. When one transitions to
// 'done', we fire a success toast — bounded to backfills the user kicked off
// (or saw running) in this session so an already-done row found on page load
// doesn't pop a stale notification.
const sessionRunningIds = new Set<string>()

/**
 * Seed Redux with a backfill row and re-discover all running jobs by merchant ID.
 * Re-discovery (same path as a page refresh) keeps the poll token from going
 * stale when a second backfill starts while one is already polling.
 */
export const watchBackfill = (backfillRow) => {
  return (dispatch, getState) => {
    if (!backfillRow?.id) return
    const nextBackfillToken = [localStoragePayhelm.backfillToken, backfillRow.id].filter((i) => i).join(',')
    localStoragePayhelm.backfillToken = nextBackfillToken
    sessionRunningIds.add(String(backfillRow.id))
    const existing = getState().backfill.backfill || []
    const backfills = existing.map((b) => b.id).includes(backfillRow.id)
      ? existing
      : [...existing, backfillRow]
    dispatch({ type: 'FETCH_FULFILLED_BACKFILL', payload: backfills })
    backfillPollGeneration += 1
    const merchantIds = (getState().root?.accounts || []).map((a) => a.merchant_id).filter(Boolean)
    if (merchantIds.length) {
      clearTimeout(backfillInterval)
      backfillInterval = null
      return fetchBackfillStatus('', merchantIds)(dispatch)
    }
    // No accounts yet — fall back to token-based poll so we don't blank the banner.
    clearTimeout(backfillInterval)
    backfillInterval = setTimeout(() => fetchBackfillStatus(nextBackfillToken)(dispatch), 3000)
  }
}

/** Re-query running/errored backfills by merchantIds (same as BackfillBanner mount). */
export const discoverRunningBackfills = () => {
  return (dispatch, getState) => {
    const merchantIds = (getState().root?.accounts || []).map((a) => a.merchant_id).filter(Boolean)
    backfillPollGeneration += 1
    clearTimeout(backfillInterval)
    backfillInterval = null
    return fetchBackfillStatus('', merchantIds)(dispatch)
  }
}

export const fetchBackfill = (user, channel, options) => {
  return async (dispatch, getState) => {

    // let backfillUrl = getBackfill
    // let _user = user
    // if (channel === 'Shopify') {
    //   backfillUrl = getShopifyBackfill
    //   if (options && options.order) {
    //     backfillUrl += '_for_order'
    //   }
    //   else if (options) {
    //     backfillUrl += options.type ? `_${options.type}_date` : `_days`
    //   }
    //   _user = user.match(/.myshopify.com$/) ? user : user + '.myshopify.com'
    // }
    // else if (channel === 'Paypal') {
    //   backfillUrl = getPaypalBackfill
    // }
    // else if (channel === 'Paypal Merchant') {
    //   backfillUrl = getMerchantPaypalBackfill
    // }
    // else if (channel === 'Bigcommerce') {
    //   backfillUrl = getBigcommerceBackfill
    //   if (options && options.order) {
    //     backfillUrl += '_for_order'
    //   }
    //   else if (options) {
    //     backfillUrl += options.type ? `_${options.type}_date` : `_days`
    //   }
    // }
    // else if (channel === 'Woocommerce') {
    //   backfillUrl = getWoocommerceBackfill
    //   if (options) {
    //     backfillUrl += options.type ? `_${options.type}_date` : `_days`
    //   }
    // }
    // else {
    //   backfillUrl = getBackfill
    // }

    const { user: _user, url: backfillUrl, startDate, endDate, } = getTriggerBackfillDetails(user, channel, options)
    const timezone = _.get(getState(), ['root', 'user', 'default_timezone'], 'utc')
    dispatch({ type: 'FETCH_BACKFILL' })
    try {
      const { data: response } = await axios.post(backfillUrl, { user_id: _user, timezone, custom_start_date: startDate, custom_end_date: endDate, ...options }, { withCredentials: true })
      dispatch(watchBackfill(response))
      return { ok: true, data: response }
    } catch (err) {
      console.log('fetchBackfill err', err)
      clearTimeout(backfillInterval)
      delete localStoragePayhelm.backfillToken
      dispatch({ type: 'FETCH_REJECTED_BACKFILL', payload: err })
      const status = err?.response?.status
      const body = err?.response?.data
      const message =
        (typeof body === 'string' && body) ||
        body?.error ||
        body?.message ||
        err?.message ||
        'Failed to start backfill'
      return { ok: false, status, message, error: err }
    }
  }
}

/** Re-queue full import batch for search indexing (same payload as post-import ping). */
export const fetchInkfrogOrdersImportBackfill = (payload: { import_id: string }) => {
  return async (dispatch, getState) => {
    dispatch({ type: 'FETCH_BACKFILL' })
    try {
      const { data: response } = await axios.post(inkfrogOrdersBackfillUrl, payload, getAxiosDefaultConfig())
      if (response?.id) {
        dispatch(watchBackfill(response))
      } else {
        dispatch({ type: 'FETCH_FULFILLED_BACKFILL', payload: getState().backfill.backfill })
      }
    } catch (err) {
      console.log('fetchInkfrogOrdersImportBackfill err', err)
      clearTimeout(backfillInterval)
      delete localStoragePayhelm.backfillToken
      dispatch({ type: 'FETCH_REJECTED_BACKFILL', payload: err })
    }
  }
}

export const fetchBackfillStatus = (token, merchantIds) => {
  return async (dispatch) => {
    const pollGeneration = backfillPollGeneration
    dispatch({ type: 'FETCH_BACKFILL' })
    try {
      const { data: response } = await axios.post(getBackfillStatus, { token, merchantIds }, { withCredentials: true })
      // A newer watch/discover started while this request was in flight — drop stale result.
      if (pollGeneration !== backfillPollGeneration) {
        return
      }
      const backfillsInProgress = response.filter((r) => r.status === 'running')
      const backfillsWithErrors = response.filter((r) => r.status === 'error')
      const idsInProgress = backfillsInProgress.map((r) => r.id).join(',')

      // Track new running IDs (covers the "page already had a backfill running
      // before we mounted" case — first poll picks it up here).
      backfillsInProgress.forEach((r) => sessionRunningIds.add(String(r.id)))
      // Fire success toast for running → done transitions we were tracking.
      response
        .filter((r) => r.status === 'done' && sessionRunningIds.has(String(r.id)))
        .forEach((r) => {
          sessionRunningIds.delete(String(r.id))
          const count = r.current_period_orders_total ?? r.total ?? null
          const subject = r.merchant_id || r.channel || 'Backfill'
          toast.success(
            count != null
              ? `${subject}: backfill complete — ${count} order${count === 1 ? '' : 's'} synced`
              : `${subject}: backfill complete`,
          )
        })
      if (response.length) {
        if (token) {
          // Follow-up fetch
          dispatch({ type: 'FETCH_FULFILLED_BACKFILL', payload: response })
        } else if (backfillsInProgress.length || backfillsWithErrors.length) {
          // Initial fetch — include both running and errored backfills
          dispatch({ type: 'FETCH_FULFILLED_BACKFILL', payload: [...backfillsInProgress, ...backfillsWithErrors] })
        }
      }
      if (idsInProgress.length) {
        backfillInterval = setTimeout(() => fetchBackfillStatus(idsInProgress)(dispatch), 3000)
        localStoragePayhelm.backfillToken = idsInProgress
      } else {
        clearTimeout(backfillInterval)
        backfillInterval = null
        delete localStoragePayhelm.backfillToken
        setCookie('backfill_token', '')
        setTimeout(() => {
          dispatch({ type: 'RESET_BACKFILL' })
        }, 3000)
      }
    } catch (err) {
      if (pollGeneration !== backfillPollGeneration) {
        return
      }
      clearTimeout(backfillInterval)
      backfillInterval = null
      dispatch({ type: 'FETCH_REJECTED_BACKFILL', payload: err })
    }
  }
}

export const fetchRunningBackfills = () => {
  return async (dispatch, getState) => {
    dispatch({ type: 'FETCH_BACKFILL' })
    try {
      const { runningBackfill, finishedBackfill, failedBackfill, adminPage } = getState().backfill
      const backfillIds = runningBackfill.map((r) => r.id)
      const { data: response } = await axios.post(getBackfillRunningStatus, { backfillIds }, { withCredentials: true })
      const backfillsInProgress = response
        .filter((r) => r.status === 'running')
        .map((b) => ({ ...b, created_at: new Date(b.created_at) }))
      const backfillsFinished = response
        .filter((r) => r.status === 'done')
        .map((b) => ({ ...b, created_at: new Date(b.created_at) }))
      const backfillsFailed = response
        .filter((r) => r.status === 'error')
        .map((b) => ({ ...b, created_at: new Date(b.created_at) }))
      dispatch({
        type: 'SET_FINISHED_BACKFILL',
        payload: [
          ...backfillsFinished.map((b) => ({
            ...b,
            finished_at: new Date(),
          })),
          ...finishedBackfill,
        ],
      })
      dispatch({
        type: 'SET_FAILED_BACKFILL',
        payload: [
          ...backfillsFailed.map((b) => ({
            ...b,
            failed_at: new Date(),
          })),
          ...failedBackfill,
        ],
      })
      dispatch({ type: 'FETCH_FULFILLED_RUNNING_BACKFILL', payload: backfillsInProgress })
      if (adminPage) {
        runningBackfillInterval = setTimeout(() => fetchRunningBackfills()(dispatch, getState), 5000)
      } else {
        clearTimeout(runningBackfillInterval)
        runningBackfillInterval = null
      }
    } catch (err) {
      console.error(err)
      clearTimeout(runningBackfillInterval)
      runningBackfillInterval = null
      dispatch({ type: 'FETCH_REJECTED_RUNNING_BACKFILL', payload: err })
    }
  }
}

export const switchBackfill = (index) => {
  return {
    type: 'SWITCH_BACKFILL',
    payload: index,
  }
}

export const dismissBackfillError = (backfillId) => {
  return {
    type: 'DISMISS_BACKFILL_ERROR',
    payload: backfillId,
  }
}

export const toggleAdminPage = (flag) => {
  return {
    type: 'TOGGLE_ADMIN_PAGE_BACKFILL',
    payload: flag,
  }
}
